/**
 * 广告位配置
 */

export default {
    horizontal: {
        actorBottom: [],
        productBottom: [],
        actorSeachList: [
            {
                'img': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/advertisement/fint-actor-banner.png',
                'name': '搜索1',
                'type': 'actor',
                'id': '',
            }
        ],
        productSeachList: [
            {
                'img': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/advertisement/fint-product-banner.png',
                'name': '搜索',
                'type': 'product',
                'id': '',
            }
        ],
    },
    leftList: {
        'actorFindlist': [],
        'productFindlist': [],
        'opportunity': [],
        'live': [],
        'report': [],
        'workList': []
    },
    rightList: {
        'actorFindlist': [],
        'productFindlist': [],
        'opportunity': [],
        'live': [],
        'report': [],
        'workList': [
            // {
            //     'img': 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/baoli/advertisement/xieAn.gif',
            //     'name': '展商1',
            //     'type': 'actor',
            //     'id': '9b8421b322af43ef87bbb2c15fb49b08',
            // }
        ]
    }
  }